import React from "react";
import Breadcrumb from "./breadcrumb";
import Security from "../components/security";

const Title = ({ route }) => {
    const user = Security.getUser();

    return (
        <div className="title">
            <div className="wrapper">
                <Breadcrumb route={route}/>
                <h1>{route.title}</h1>
                {route.showUser && user && <h4>{user.DisplayName} ({user.EtudiantMatricule})</h4>}
            </div>
        </div>
    );
};

export default Title